'use client'

import { useContext } from 'react'
import { useTranslation } from '../../context/ConfigContext'
import { UserContext } from '../../context/UserContext'
import { Button } from '../Button/Button'

export default function LoginButtonNewsletter() {
  const { isLogged } = useContext(UserContext)
  const account: string = isLogged ? '/customer/account' : '/customer/login'
  const t = useTranslation()

  return (
    <Button
      classname='border-black'
      size='large'
      href={account}
      label={t('I have an account', {}, false)}
      style='light'
    />
  )
}
